class VisualNodes {
  #nodes = new Map();

  set(key, value) {
    this.#nodes.set(key, value);
  }

  get(key) {
    return this.#nodes.get(key);
  }

  delete(key) {
    this.#nodes.delete(key);
  }
}

const visualNodes = new VisualNodes();
export { VisualNodes, visualNodes };
